import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/layout' // 全局布局

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: "/login",
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: {title: '首页', showSearchIcon: true},
        component: () => import('@/views/home/index.vue')
      },
      {
        path: '/library',
        name: 'library',
        meta: {title: '首页', showSearchIcon: true},
        component: () => import('@/views/library/index.vue')
      },
      {
        path: '/record',
        name: 'Record',
        meta: {title: '学习记录', showSearchIcon: false},
        component: () => import('@/views/record/index.vue')
      },
      {
        path: '/live',
        name: 'Live',
        meta: {title: '直播课程', showSearchIcon: true},
        component: () => import('@/views/live/index.vue')
      },
      {
        path: '/referral',
        name: 'Referral',
        meta: {title: '推荐课程', showSearchIcon: true},
        component: () => import('@/views/referral/index.vue')
      },
      {
        path: '/entry',
        name: 'Entry',
        meta: {title: '客户录入', showSearchIcon: false},
        component: () => import('@/views/entry/index.vue')
      },
      {
        path: '/entryRecord',
        name: 'EntryRecord',
        meta: {title: '报备记录', showSearchIcon: true},
        component: () => import('@/views/entryRecord/index.vue')
      },
      {
        path: '/subManagement',
        name: 'SubManagement',
        meta: {title: '子账号管理', showSearchIcon: false},
        component: () => import('@/views/SubManagement/index.vue')
      },
      {
        path: '/balance',
        name: 'Balance',
        meta: {title: '流水记录', showSearchIcon: false},
        component: () => import('@/views/balance/index.vue')
      },
      {
        path: '/subList',
        name: 'SubList',
        meta: {title: '我的下级用户', showSearchIcon: false},
        component: () => import('@/views/subList/index.vue')
      },
      {
        path: '/studyPath',
        name: 'StudyPath',
        meta: {title: '自定义学习路线', showSearchIcon: false},
        component: () => import('@/views/StudyPath/index.vue')
      },
      {
        path: '/training',
        name: 'Training',
        meta: {title: '培训教学', showSearchIcon: false},
        component: () => import('@/views/training/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 不需要验证的白名单
const whiteList = ['/login', '/cate']

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters.token
  const hasUserInfo = store.getters.hasUserInfo

  if (hasToken) {
    if (to.path === '/login') {
      next() // 不跳转
      return
    }

    // 👇 关键：已经有信息了，就不再获取！
    if (!hasUserInfo) {
      try {
        await store.dispatch('getUserInfo')
      } catch (e) {
        await store.dispatch('logout')
        next('/login')
        return
      }
    }
    next()
  } else {
    whiteList.includes(to.path) ? next() : next('/login')
  }
})

export default router
